module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content validate-wraper"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText'),
      "back": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t("basic.slelctCountry")))])]), _vm._v(" "), _c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('country-com', {
    attrs: {
      "lang": _vm.lang
    },
    model: {
      value: (_vm.countryInfo),
      callback: function($$v) {
        _vm.countryInfo = $$v
      },
      expression: "countryInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setCountry
    }
  }, [_vm._v(_vm._s(_vm.$t("basic.Submit")))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68664c8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68664c8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/country/country.vue
// module id = 163
// module chunks = 1 2